import { render, staticRenderFns } from "./UiHighlight.vue?vue&type=template&id=f414f2da&"
import script from "./UiHighlight.vue?vue&type=script&lang=ts&"
export * from "./UiHighlight.vue?vue&type=script&lang=ts&"
import style0 from "./UiHighlight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports